import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import { useGetInvoiceScansApi } from './use-get-invoice-scans-api';

const endpoint = 'ums/v1/cms/invoice-scanning/scans';

type TData = Record<string, any>;
type TError = AxiosError;
type TVariables = { scanId: number; validationStatus: string };
type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useUpdateInvoiceScanStatusApi(options?: Options): ReturnType {
  const { refetch: refetchScans } = useGetInvoiceScansApi({ enabled: false });
  const toast = useCustomToast();

  const mutationFn = async ({ scanId, validationStatus }: TVariables) => {
    try {
      const { data } = await http.patch(`${endpoint}/${scanId}/status`, { validationStatus });
      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, {
    ...options,
    mutationKey: [endpoint],
    onSuccess: () => {
      refetchScans();
      toast({
        description: 'Validation status has been updated successfully',
        status: 'success',
      });
    },
  });
}
